import axios from 'axios';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchPredesTransactionsHistory = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getPredesTransactionsHistory',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
      transactionId: payload.params.transactionId,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchPredesTransactionsHistory;
